import { useGoogleAnalytics } from "@/main/config/google-analytics/useGoogleAnalytics";
import { ErrorBoundary } from "@/shared/presentation/components/error-boundary";
import { LoadingFullPage } from "@/shared/presentation/components/loading-full-page";
import React from "react";
import { Redirect, Route, Switch } from "react-router";
import { NotFound } from "../pages";
import { PrivateRoutes } from "./private-routes";
import { getCachedAuthClientInstance } from "@/main/singleton/cached-auth-client-instance";
import { CookieProvider } from "@/shared/presentation/context-api/providers/cookie";
import { SaveAuthCookieContainer } from "@/features/save-auth-cookie/containers";
var LoginApp = React.lazy(function () { return import("account/Providers"); });
export var Routes = function () {
    var googleAnalytics = useGoogleAnalytics();
    return (React.createElement(Switch, null,
        React.createElement(Route, { path: "/save-cookie", exact: true },
            React.createElement(CookieProvider, { authClient: getCachedAuthClientInstance() },
                React.createElement(SaveAuthCookieContainer, null))),
        React.createElement(Route, { exact: true, path: "/" },
            React.createElement(Redirect, { to: "/home" })),
        React.createElement(Route, { path: ["/login", "/recover", "/recover/:token"] },
            React.createElement(ErrorBoundary, null,
                React.createElement(React.Suspense, { fallback: React.createElement(LoadingFullPage, null) },
                    React.createElement(NotFound, null),
                    React.createElement("div", { style: { display: "none" } },
                        React.createElement(LoginApp, null))))),
        React.createElement(Route, { path: [
                "/google-failure",
                "/google-success",
                "/login-success",
                "/social-login-success",
            ] },
            React.createElement(ErrorBoundary, null,
                React.createElement(React.Suspense, { fallback: React.createElement(LoadingFullPage, null) },
                    React.createElement(LoginApp, null)))),
        React.createElement(PrivateRoutes, { googleAnalytics: googleAnalytics }),
        React.createElement(Route, { exact: true, path: "/404-not-found", component: NotFound }),
        React.createElement(Redirect, { to: "/404-not-found" })));
};
